module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.6976/img/callout-blobs.svg"